export default __webpack_public_path__ + "static/media/Detonator.256.a46ab56b.png";